import React from 'react'
import { CLASS_PREFIX } from 'src/constants'
import { textResources } from 'src/lang/de'

import './project_list_empty_state.scss'

type Props = {
  openCreateProject?: () => void;
};

const cls = `${CLASS_PREFIX}project-list-wrapper`

const t = textResources.projects

export const ProjectListEmptyState: React.FC<Props> = ({
  openCreateProject
}) => {
  return (
    <div className={`${cls}__state`}>
      <div className={`${cls}__state-text`}>
        <div className={`${cls}__state-title`}>
          {t.overview.noProjectsTitle}
        </div>
        <div className={`${cls}__state-message`}>
          {t.overview.noProjectsMessage}
        </div>
      </div>
      {!!openCreateProject && (
        <div className={`${cls}__state-actions`}>
          <button
            type="button"
            className={`${cls}__state-button`}
            onClick={openCreateProject}
          >
            {t.overview.ctaHaveConcern}
          </button>
        </div>
      )}
    </div>
  )
}
